function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.204 13.013L.611 9.206a.222.222 0 01.017-.392L18.625.529 7.205 13.013zM19.5.88l-3.26 17.01a.22.22 0 01-.125.16.218.218 0 01-.203-.01l-7.925-4.575L19.499.88h.001zM7.714 14.326l3.23 1.866L8.1 19.397a.22.22 0 01-.386-.147v-4.924z",
  fill: "#4B4B4B"
})));